import Swiper from "swiper/bundle";

export const frontPage = () => {
  if (document.body.classList.contains("home")) {
    // バナーのスライダー
    const exhibitionInfoSlider = new Swiper(".exhibition-info-slider", {
      spaceBetween: 20,
      centeredSlides: true,
      pagination: {
        el: ".exhibition-info-slider-swiper-pagination",
      },
      breakpoints: {
        1024: {
          centeredSlides: false,
          allowTouchMove: false,
          slidesPerView: 3,
        },
      },
    });

    // レンタル衣装・髪飾りのスライダー
    const sectionSliderSettings = {
      slidesPerView: 2.2,
      spaceBetween: 16,
      breakpoints: {
        1024: {
          slidesPerView: "auto",
          spaceBetween: 40,
        },
      },
    };

    const sectionSliderSwiper1 = new Swiper(".rental-furisode-slider", sectionSliderSettings);
    const sectionSliderSwiper2 = new Swiper(".accessory-slider", sectionSliderSettings);
    const sectionSliderSwiper3 = new Swiper(".hair-style-slider", sectionSliderSettings);
  }
};
